import { MonoBehavior } from './core/monoBehavior';
import { translate } from 'game/translate';
import { SoundManager } from 'game/core/soundManager';
import { Store } from './store/gameStore';
import { GameEvent } from './events/gameEvent';
import { EventName } from './events/eventsName';
import { openFeedbackPopup } from './feedback';
import { GAEvent, GAEventNames } from './analytics/events';
import { showPopup } from './showPopup';
import { isIOS } from './core/display';
import { KingPopup } from './KingPopup';
import { difficultyLevelData } from 'constants/difficulty';

export class WinScreen extends MonoBehavior {
    constructor() {
        super();
        addEventListener('storiesOpen', (e: CustomEvent) => {
            GAEvent(GAEventNames.STORIES_OPEN, {
                type: Store.getGameTypeText(),
                difficulty: Store.getDifficultyText(),
            });
        });

        addEventListener('showWinScreen', (e: CustomEvent) => {
            if (e.detail.moves) Store.movesCount = parseInt(e.detail.moves);
            if (e.detail.time) {
                const time = parseInt(e.detail.time) * 1000;
                Store.startTime = performance.now() - time;
                Store.stopTime = performance.now();
            }
            if (e.detail.wins) {
                Store.wins = parseInt(e.detail.wins);
                Store.gameStorage.setItem('wins', Store.wins);
            }

            this.showWinScreen();
        });
        GameEvent.add(EventName.RESET_GAME, this.hideWinScreen.bind(this));
        GameEvent.add(EventName.SHOW_WIN_AFTER_FEEDBACK, this.displayWinScreen.bind(this));
        GameEvent.add(EventName.CLOSE_MODAL, this.onModalsHide.bind(this));
    }
    onModalsHide(e: { id: string; confirm: boolean }) {
        const { id, confirm } = e;
        if (id === 'push_notifications') {
            if (confirm) {
                Store.notificationWinPopupNextShow = -1;
                Store.gameStorage.setItem('notificationWinPopupNextShow', Store.notificationWinPopupNextShow);
                GAEvent(GAEventNames.NOTIFICATION_POPUP_SUBSCRIBE, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('push_notifications'),
                });
                new KingPopup('thanksSubscribing');
            } else {
                Store.notificationWinPopupNextShow += 20;
                Store.gameStorage.setItem('notificationWinPopupNextShow', Store.notificationWinPopupNextShow);

                GAEvent(GAEventNames.NOTIFICATION_POPUP_SKIP, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('push_notifications'),
                });
            }
            this.displayWinScreen();
        }
        if (id === 'stories_use_tickets') {
            if (confirm) {
                GAEvent(GAEventNames.STORIES_USE_TICKET_BANNER_OPEN, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('stories_use_tickets'),
                });
            } else {
                GAEvent(GAEventNames.STORIES_USE_TICKET_BANNER_CLOSE, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('stories_use_tickets'),
                });
            }
            this.displayWinScreen();
        }
        if (id === 'facebook-banner') {
            if (confirm) {
                Store.facebookWinPopupNextShow = -1;
                Store.gameStorage.setItem('facebookWinPopupNextShow', Store.facebookWinPopupNextShow);

                Store.setWandCounter(Store.wandCounter + 5);
                GAEvent(GAEventNames.FACEBOOK_BANNER_FOLLOW, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('facebook-banner'),
                });

                const url = 'https://www.facebook.com/solitairescom';
                if (isIOS()) window.location.href = url;
                else window.open(url, '_blank');
            } else {
                GAEvent(GAEventNames.FACEBOOK_BANNER_CLOSE, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('facebook-banner'),
                });
            }
            this.displayWinScreen();
        }
    }
    hideWinScreen() {
        const popup = document.getElementById('win-popup-wrapper');
        if (popup) {
            popup.classList.remove('active');
        }
    }
    displayWinScreen() {
        SoundManager.play('winPopupSFX');

        const popup = document.getElementById('win-popup-wrapper');

        if (popup) {
            popup.classList.add(`win-popup-game-${Store.name}`);

            dispatchEvent(new CustomEvent('showWinPopup'));
            const scoreValue = document.getElementById('win-popup-score');
            const scoreLabel = document.getElementById('win-popup-score-label');

            if (scoreValue && scoreLabel) {
                scoreValue.innerText = Store.score.toString();
                scoreLabel.innerText = translate('score') + ':';
            }

            const timeValue = document.getElementById('win-popup-time');
            const timeLabelLabel = document.getElementById('win-popup-time-label');
            timeValue!.innerText = Store.getTimeFormat(Store.time);
            timeLabelLabel!.innerText = translate('time') + ':';

            const movesValue = document.getElementById('win-popup-moves');
            const movesLabel = document.getElementById('win-popup-moves-label');
            movesValue!.innerText = Store.movesCount.toString();
            movesLabel!.innerText = translate('moves') + ':';

            const buttonLabel = document.getElementById('win-popup-button-label');
            buttonLabel!.innerText = translate('newDeal');

            const button = document.getElementById('win-popup-button');
            if (button) {
                button.onclick = () => {
                    dispatchEvent(new CustomEvent('newWinGame'));
                };
            }

            const tickets = document.getElementById('stories-tickets-won');
            if (tickets) {
                tickets.innerText = 'x' + this.ticketByDifficulty();
                dispatchEvent(new CustomEvent('updateTickets', { detail: this.ticketByDifficulty() }));
            }
            this.showStatistics(popup);
        }
    }
    showStatistics(popup: HTMLElement) {
        const bestValueClassName = 'best-record';
        const timeRow = document.getElementById('win-popup-row-time');
        const movesRow = document.getElementById('win-popup-row-moves');
        const bestTimeRow = document.getElementById('win-popup-time-best-value');
        const bestMovesRow = document.getElementById('win-popup-moves-best-value');
        if (!timeRow || !movesRow) return;
        if (!bestTimeRow || !bestMovesRow) return;
        timeRow.classList.remove(bestValueClassName);
        movesRow.classList.remove(bestValueClassName);
        if (Store.gamesWinScore) {
            let moveValue = 0; //worst
            let timeValue = 0; //worst

            bestTimeRow.innerText = Store.getTimeFormat(Store.gamesWinScore.minTime);
            bestMovesRow.innerText = Store.gamesWinScore.minMoves.toString();

            popup.classList.add('show-statistics');
            if (Store.movesCount <= Store.gamesWinScore.minMoves) {
                moveValue = 1;
                movesRow.classList.add(bestValueClassName);
            } else if (Store.movesCount < Store.gamesWinScore.medianMoves) {
                moveValue =
                    0.5 +
                    (0.5 * (Store.gamesWinScore.medianMoves - Store.movesCount)) /
                        (Store.gamesWinScore.medianMoves - Store.gamesWinScore.minMoves);
            } else if (Store.movesCount < Store.gamesWinScore.maxMoves) {
                moveValue =
                    (0.5 * (Store.gamesWinScore.maxMoves - Store.movesCount)) /
                    (Store.gamesWinScore.maxMoves - Store.gamesWinScore.medianMoves);
            }
            if (Store.time <= Store.gamesWinScore.minTime) {
                timeValue = 1;
                timeRow.classList.add(bestValueClassName);
            } else if (Store.time < Store.gamesWinScore.medianTime) {
                timeValue =
                    0.5 +
                    (0.5 * (Store.gamesWinScore.medianTime - Store.time)) /
                        (Store.gamesWinScore.medianTime - Store.gamesWinScore.minTime);
            } else if (Store.time < Store.gamesWinScore.maxTime) {
                timeValue =
                    (0.5 * (Store.gamesWinScore.maxTime - Store.time)) /
                    (Store.gamesWinScore.maxTime - Store.gamesWinScore.medianTime);
            }
            const totalPercentage = (moveValue + timeValue) / 2;
            const rPrc = document.getElementById('record-percentage');
            if (rPrc) {
                rPrc.innerText = (Math.round(totalPercentage * 1000) / 10).toLocaleString();
            }
        } else {
            popup.classList.remove('show-statistics');
        }
    }
    ticketByDifficulty() {
        switch (difficultyLevelData[Store.difficulty].type) {
            case 'easy':
                return 1;
            case 'medium':
                return 2;
            case 'expert':
                return 4;
            case 'master':
                return 5;

            default:
                return 3;
        }
    }

    showWinScreen() {
        if (Store.showFeedbackOnWin()) {
            openFeedbackPopup('win');
            return;
        }
        if ('Notification' in window && Store.isMobile) {
            if (
                Store.countPopupShown('push_notifications') < 3 &&
                Store.notificationWinPopupNextShow !== -1 &&
                Store.wins >= Store.notificationWinPopupNextShow &&
                Notification.permission === 'default'
            ) {
                showPopup('push_notifications');

                GAEvent(GAEventNames.NOTIFICATION_POPUP_SHOW, {
                    type: Store.getGameTypeText(),
                    difficulty: Store.getDifficultyText(),
                    number: Store.countPopupShown('push_notifications'),
                });
                return;
            }
        }
        if (
            Store.countPopupShown('facebook-banner') < 3 &&
            Store.language === 'en' &&
            Store.facebookWinPopupNextShow !== -1 &&
            Store.wins >= Store.facebookWinPopupNextShow
        ) {
            showPopup('facebook-banner');
            GAEvent(GAEventNames.FACEBOOK_BANNER_VIEW, {
                type: Store.getGameTypeText(),
                difficulty: Store.getDifficultyText(),
                number: Store.countPopupShown('facebook-banner'),
            });

            Store.facebookWinPopupNextShow += 20;
            Store.gameStorage.setItem('facebookWinPopupNextShow', Store.facebookWinPopupNextShow);
            return;
        }
        if (this.showTicketPopup()) return;
        this.displayWinScreen();
    }

    showTicketPopup() {
        if (Store.countPopupShown('stories_use_tickets') >= 3) return false;

        const tokensLimit = 20;
        if (Store.storiesViewed) return false;
        if (parseInt(localStorage.getItem('stories_tickets_counter')) < tokensLimit) return false;
        if (Store.storiesNextPopup > Store.wins) return false;

        showPopup('stories_use_tickets');
        GAEvent(GAEventNames.STORIES_USE_TICKET_BANNER_VIEW, {
            type: Store.getGameTypeText(),
            difficulty: Store.getDifficultyText(),
            number: Store.countPopupShown('stories_use_tickets'),
        });
        Store.storiesNextPopup = Store.wins + 20;
        Store.gameStorage.setItem('storiesNextPopup', Store.storiesNextPopup);
        return true;
    }
}
